exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nbody[data-v-c435333a] {\n\toverflow-x: unset !important;\n}\n", ""]);

// exports
